"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var react_dom_1 = require("react-dom");
var utils_1 = require("@prezzee/utils");
function getContainer(container) {
    return typeof container === 'function' ? container() : container;
}
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 */
var Portal = (0, react_1.forwardRef)(function (props, ref) {
    var children = props.children, container = props.container, _a = props.disablePortal, disablePortal = _a === void 0 ? false : _a;
    var _b = __read((0, react_1.useState)(null), 2), mountNode = _b[0], setMountNode = _b[1];
    // @ts-ignore
    var handleRef = (0, utils_1.useForkRef)((0, react_1.isValidElement)(children) ? children.ref : null, ref);
    (0, utils_1.useEnhancedEffect)(function () {
        if (!disablePortal) {
            setMountNode(getContainer(container) || document.body);
        }
    }, [container, disablePortal]);
    (0, utils_1.useEnhancedEffect)(function () {
        if (mountNode && !disablePortal) {
            (0, utils_1.setRef)(ref, mountNode);
            return function () {
                (0, utils_1.setRef)(ref, null);
            };
        }
        return undefined;
    }, [ref, mountNode, disablePortal]);
    if (disablePortal) {
        if ((0, react_1.isValidElement)(children)) {
            return (0, react_1.cloneElement)(children, {
                ref: handleRef,
            });
        }
        return children;
    }
    return mountNode ? (0, react_dom_1.createPortal)(children, mountNode) : mountNode;
});
exports.default = Portal;
//# sourceMappingURL=Portal.js.map